import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Calculator, FolderKanban, Settings, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import styles from './Layout.module.css';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, user } = useAuth();

  const isActive = (path: string) => location.pathname === path;

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div className={styles.layout}>
      <div className={styles.topBarContainer}>
        <nav className={styles.floatingBar}>
          <div className={styles.navLinks}>
            <Link
              to="/"
              className={`${styles.navLink} ${isActive('/') ? styles.navLinkActive : ''}`}
            >
              <Calculator size={18} />
              <span>Calculadora</span>
            </Link>
            <Link
              to="/planner"
              className={`${styles.navLink} ${isActive('/planner') ? styles.navLinkActive : ''}`}
            >
              <FolderKanban size={18} />
              <span>Proyectos</span>
            </Link>
            <Link
              to="/config"
              className={`${styles.navLink} ${isActive('/config') ? styles.navLinkActive : ''}`}
            >
              <Settings size={18} />
              <span>Configuración</span>
            </Link>
          </div>
          <div className={styles.userSection}>
            {user && <span className={styles.userEmail}>{user.email}</span>}
            <button onClick={handleLogout} className={styles.logoutButton} title="Cerrar sesión">
              <LogOut size={18} />
            </button>
          </div>
        </nav>
      </div>
      <main className={styles.main}>{children}</main>
    </div>
  );
}
